export default __webpack_public_path__ + "static/media/man-1.1725ab57.png";